export const INVENTORY = '[INVENTORY]'
export const ADD_INVENTORY_ITEMS = `${INVENTORY} Add Items to Inventory`
export const DELETE_INVENTORY_ITEMS = `${INVENTORY} Delete Items from Inventory`
export const UPDATE_INVENTORY_ITEM = `${INVENTORY} Update Item in Inventory`
export const INIT_INVENTORY = `${INVENTORY} Initialise Items in Inventory`

export const addInventoryItems = items => ({
    type: ADD_INVENTORY_ITEMS,
    payload: {
        items,
    },
    meta: {
        persisted: 'inventory',
    },
})

export const deleteInventoryItems = targets => ({
    type: DELETE_INVENTORY_ITEMS,
    payload: {
        targets,
    },
    meta: {
        persisted: 'inventory',
    },
})

export const updateInventoryItem = action => ({
    type: UPDATE_INVENTORY_ITEM,
    payload: {
        target: action.target,
        changedStatus: action.changedStatus,
    },
    meta: {
        persisted: 'inventory',
    },
})

export const initialiseInventory = () => ({
    type: INIT_INVENTORY,
    payload: {},
    meta: {
        persisted: 'inventory',
        initGameAction: true,
    },
})
